import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { WorkspaceTaskGroupRow } from "../workspaceTaskGroupsViewConfig";

interface TaskGroupActionsCallbacks {
    onEditTaskGroup: (taskGroupId: string) => void;
    onDeleteTaskGroup: (taskGroupId: string) => void;
}

interface TaskGroupActionsOptions {
    scope: "workspace" | "organization";
}

type TaskGroupActionsMeta = ViewTableMeta<
    TaskGroupActionsCallbacks,
    TaskGroupActionsOptions
>;

export const TaskGroupActionsCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, WorkspaceTaskGroupRow, string>) => {
        const meta = (table.options.meta ?? {}) as TaskGroupActionsMeta;
        const taskGroupId = row.original.id;
        const isSystemTaskGroup = !!row.original.systemKey;
        const isOrganizationScopedTaskGroup = !!row.original.organizationId;
        const shouldDisableActions =
            (meta.options?.scope === "workspace" &&
                isOrganizationScopedTaskGroup) ||
            isSystemTaskGroup;

        if (
            !meta.callbacks?.onEditTaskGroup ||
            !meta.callbacks?.onDeleteTaskGroup
        ) {
            return null;
        }

        return (
            <ViewTableCell captureClicks>
                <Menu.More
                    className={viewTableStyles.showOnHover}
                    disabled={shouldDisableActions}
                >
                    <Menu.Item
                        onClick={() =>
                            meta.callbacks?.onEditTaskGroup(taskGroupId)
                        }
                    >
                        Edit
                    </Menu.Item>
                    <Menu.Item
                        destructive
                        onClick={() =>
                            meta.callbacks?.onDeleteTaskGroup(taskGroupId)
                        }
                    >
                        Delete
                    </Menu.Item>
                </Menu.More>
            </ViewTableCell>
        );
    },
);
